// noinspection ES6UnusedImports
import React, {Fragment} from 'react';
import {Typography} from '@bonprix/design-system';

export default function Benefit({heading, text, icon}) {
    return (
        <div className="cart__benefit">
            <div className="cart__benefit__icon">
                <div className="cart__benefit__icon__size">
                    {icon}
                </div>
            </div>
            <div className="cart__benefit__text">
                <Typography bold>{heading}</Typography>
                <Typography>{text}</Typography>
            </div>
        </div>
    );
}
